// extracted by mini-css-extract-plugin
export default {"container":"player_container__EZQAB","image":"player_image__aHMBz","text":"player_text__GUObi","line":"player_line__ikYRB","sidebar_image":"player_sidebar_image__IqqsL"};